import React from 'react';
import './App.css';
import {  BrowserRouter as Router, Switch, Route, Link, Redirect } from 'react-router-dom';
import Home from './screens/Home/Home';
import Ask from './screens/Ask/Ask';
import Terms from './screens/Terms/Terms';
import Privacy from './screens/Privacy/Privacy';
import Feedback from './screens/Feedback/Feedback';
import Help from './screens/Help/Help';
import Signup from './screens/Signup/Signup';
import RequestAccess from './screens/RequestAccess/RequestAccess';
import Onboarding from './screens/Onboarding/Onboarding';
import LiveResume from './screens/LiveResume/LiveResume';
import Dashboard from './screens/Dashboard/Dashboard';
import Stream from './screens/Stream/Stream';
import JobList from './screens/Job/JobList/JobList';
import JobDetails from './screens/Job/JobDetails/JobDetails';
import Explore from './screens/Explore/Explore';
import Competency from './screens/Competency/Competency';
import DemoApp from './demo/DemoApp/DemoApp';
import Learn from './screens/Learn/Learn';
import Invite from './screens/Invite/Invite';
import CourseList from './screens/Course/CourseList/CourseList';
import CourseItemList from './screens/Course/CourseItemList/CourseItemList';
import CourseDetail from './screens/Course/CourseDetail/CourseDetail';

export default class App extends React.Component {

    constructor(props) {
        super(props);
    };

    render() {
        return (
            <Router>
                <Switch>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/signin" component={Signup} />
                    <Route exact path="/request-access" component={RequestAccess} />
                    <Route exact path="/onboarding" component={Onboarding} />

                    <Route exact path="/live-resume" component={LiveResume} />
                    <Route exact path="/dashboard" component={Dashboard} />
                    <Route exact path="/stream" component={Stream} />
                    <Route exact path="/explore" component={Explore} />
                    <Route exact path="/ask" component={Ask} />
                    <Route exact path="/jobs-center" component={JobList} />
                    <Route exact path="/job-list" component={JobList} />
                    <Route exact path="/job-details" component={JobDetails} />
                    <Route exact path="/my-courses" component={CourseList} />
                    <Route exact path="/course-item-list" component={CourseItemList} />
                    <Route exact path="/course-detail" component={CourseDetail} />
                    <Route exact path="/competency-matrix" component={Competency} />
                    <Route exact path="/learn" component={Learn} />
                    <Route exact path="/invite" component={Invite} />

                    <Route exact path="/demo" component={DemoApp} />
                    {/* <Route exact path="/terms" component={Terms} />
                    <Route exact path="/privacy" component={Privacy} />
                    <Route exact path="/help" component={Help} />

                    {/* <Route path="/feedback/359847fb-7e05-466d-9791-ec32b1b7c10a" component={Feedback} /> */}
                    <Route path="*" component={Home} />
                </Switch>
            </Router>
        );
    };
};